import SeparatorType from "../../../types/separator-type";
import Timezone from "../../../types/timezone";

export enum DelegationDownloadParamsFileFormat {
  PDF = "PDF",
  CSV = "CSV",
}

type DelegationDownloadParams = {
  delegationUuids: string[];
  fileFormat: DelegationDownloadParamsFileFormat;
  separator?: SeparatorType;
  timezone?: Timezone;
};

export default DelegationDownloadParams;
